/* eslint-disable no-nested-ternary */
const formType = {
  general: 'general',
  testDrive: 'test_drive',
  pricing: 'pricing',
  promotion: 'specials',
  service: 'service',
  parts: 'parts',
  requestCall: 'requestCall',
  other: 'other',
};

export const formTypeFormatter = (
  isVehicleInfoAvailable: boolean,
  source: string,
  topicOfInterest: keyof typeof formType | '',
) => {
  const url = window.location.href;
  const IS_TIER1_PAGE = url.includes('audiusa.com') || url.includes('audi.ca');

  const contact = IS_TIER1_PAGE ? 'Contact' : 'contact';

  const isVinSpecific = isVehicleInfoAvailable ? 'dealervin' : 'dealer';

  if (topicOfInterest) {
    const formTypeOfTopic =
      topicOfInterest === 'general'
        ? IS_TIER1_PAGE
          ? 'generic'
          : 'general'
        : formType[topicOfInterest];
    return `${contact}_dealer-${formTypeOfTopic}`;
  }
  return `${contact}_${isVinSpecific}-${source}`;
};

export default formTypeFormatter;
